<template>
  <v-dialog v-model="visible" max-width="400px">
    <v-card :loading="loading">
      <v-card-title>Cetak Laporan Surat Keluar</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <datepicker
          v-model="filter.dateRange"
          range
          placeholder="Pilih Tanggal Surat"
          :shortcuts="datePickerShortcut"
        />
        <v-autocomplete
          label="Pengolah"
          placeholder="Semua Bidang"
          v-model="filter.pengolah"
          item-value="id"
          item-text="name"
          :items="$store.state.bidang"
          chips
          deletable-chips
          :menu-props="{ closeOnContentClick: true }"
        ></v-autocomplete>
        <v-text-field
          v-model="filter.kode"
          label="Kode Surat"
          placeholder="Semua"
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="visible = false">Tutup</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="downloadReport"
          :disabled="filter.dateRange.length < 1 || loading"
        >
          Cetak
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { getReportSuratKeluar } from '@/services/surat'
import { shortcut } from '@/utils/date-picker'

const initialFilter = {
  dateRange: [],
  pengolah: '',
  kode: ''
}

export default {
  data() {
    return {
      visible: false,
      loading: false,
      filter: { ...initialFilter },
      datePickerShortcut: shortcut
    }
  },
  computed: {},
  methods: {
    show() {
      this.filter = { ...initialFilter }
      this.visible = true
    },
    async downloadReport() {
      this.loading = true
      try {
        const params = {
          from: moment(this.filter.dateRange[0]).format('YYYY-MM-DD'),
          to: moment(this.filter.dateRange[1]).format('YYYY-MM-DD'),
          pengolah: this.filter.pengolah,
          kode: this.filter.kode
        }
        await getReportSuratKeluar(params)
        this.loading = false
        this.visible = false
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.mx-datepicker-range {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
